<div
  *ngIf="data$ | async as data"
  class="root -size-{{ getSize() }} -type-{{ type }} -state-{{ state }} -background-{{ data.background }}"
  [class.-disabled]="data.disabled"
  [class.-has-left-icon]="data.hasLeftIcon"
  [class.-has-state-icon]="state !== 'default'"
>
  <div #leftIcon class="icon -left"><ng-content select="[dsSelectLeftIcon]"></ng-content></div>
  <select
    class="select -size-{{ getSize() }} -type-{{ type }} -state-{{ state }}"
    [attr.id]="id"
    [attr.name]="name"
    [attr.disabled]="data.disabled || undefined"
    [class.-disabled]="data.disabled"
    [class.-placeholder]="!data.value"
    [style.width.px]="data.selectWidth"
    (change)="onSelectChange($event)"
    (blur)="onSelectTouch()"
    #select
  >
    <option class="placeholder-option" value="" selected disabled>{{ placeholder }}</option>
    <option
      *ngFor="let option of options$ | async"
      class="option"
      [value]="option.value"
      [selected]="option.value === data.value"
      [disabled]="option.disabled"
    >
      <ng-container *ngTemplateOutlet="option.content"></ng-container>
    </option>
  </select>
  <div *ngIf="state === 'valid'" class="icon -state-icon" [innerHTML]="getValidIcon() | skySafeHtml"></div>
  <div *ngIf="state === 'invalid'" class="icon -state-icon" [innerHTML]="getInvalidIcon() | skySafeHtml"></div>
  <div class="arrow" [innerHTML]="getArrow() | skySafeHtml"></div>
  <span class="width-calculator" #widthCalculator></span>
</div>
